import { ReactSVG } from "react-svg";

const SvgWrapper = ({ id, src, color = "#FFFFFF", gradient, gradientAngle = 180, ...props }) => {

    // Convert angle to x1, y1, x2, y2 values
    const angleRad = (gradientAngle * Math.PI) / 180;
    const x1 = 50 - 50 * Math.cos(angleRad);
    const y1 = 50 - 50 * Math.sin(angleRad);
    const x2 = 50 + 50 * Math.cos(angleRad);
    const y2 = 50 + 50 * Math.sin(angleRad);

    return (
        <svg {...props}>
            {gradient && (
                <defs>
                    <linearGradient id={id} x1={`${x1}%`} y1={`${y1}%`} x2={`${x2}%`} y2={`${y2}%`}>
                    {gradient.map((stop, index) => (
                        <stop key={index} offset={stop.offset} stopColor={stop.color} />
                    ))}
                    </linearGradient>
                </defs>
            )}
            <ReactSVG key={`${src}`} src={src} beforeInjection={(svg) => svg.querySelectorAll('path').forEach((path) => path.setAttribute('fill', gradient ? `url(#${id})` : color))} wrapper="svg" />
            {/* <path fill={gradient ? `url(#${id})` : color} d="M176.047 22.999c-82.6 0-149.3 66.7-149.3 149.3 0 28.8 9.2 56.3 22 78.899l97.3 168.399c6.1 11 18.4 16.5 30 16.5s23.3-5.5 30-16.5l97.3-168.299c12.9-22.601 22-49.601 22-78.901 0-82.598-66.7-149.398-149.3-149.398m0 193.4c-30 0-54.5-24.5-54.5-54.5s24.5-54.5 54.5-54.5 54.5 24.5 54.5 54.5c0 30.1-24.5 54.5-54.5 54.5"/> */}
        </svg>
    )
}

export default SvgWrapper;